class ClickHandler {
    constructor() {
        document.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('change', this.handleChange.bind(this));
    }

    handleClick(event) {

        if (event.target.matches('.async--grid__chip') ) {

            const container = event.target.closest('.async--grid__link');
            const variantButton = container.querySelector('.options-selection__option-value-name');
            if (variantButton) {
                variantButton.click();
                variantButton.style.boxShadow = 'none';
            }
        }

        if (event.target.matches('.options-selection__option-value-input')) {

            const container = event.target.closest('fieldset');
            const product_size_info = container.querySelector(".options-selection__option-header");
            const size_value = event.target.getAttribute('value');
            product_size_info.innerHTML = '<span class="options-selection__option-name">Size</span>: <span>' + size_value + '</span>';

        }

        if (event.target.matches('.select-cstm-option')) {

            const target = event.target;

            const selectedVarName = target.getAttribute('value');
            const selectedVarPrice = target.getAttribute('data-variant-x-price');

            const superContainer = target.closest('.options-selection__select');
            const labelName = superContainer.querySelector('.options-selection__select-label .variant-name-x');
            const labelPrice = superContainer.querySelector('.options-selection__select-label .variant-price-x');

            const variantContainer = target.closest('options-selection');
            const radioInputContainer = variantContainer.querySelector('.options-selection__option-values');    
            const radioInput = radioInputContainer.querySelector(`[value="${labelName.textContent}"]`);
            
            if (radioInput) {
                const parent = radioInput.closest('.options-selection__option-value-label');
                const inputTrigger = parent.querySelector('.variant-option-xx');

                inputTrigger.click();
            }

            labelName.textContent = selectedVarName;
            labelPrice.textContent = selectedVarPrice;
                
        }

    }

    handleChange(event) {
        const target = event.target;
        if (target.tagName === 'SELECT' && target.classList.contains('custon-select-el-xx')) {
            const selectedOption = target.options[target.selectedIndex];
            const selectedOptionName = selectedOption.value;
            const selectedOptionPrice = selectedOption.getAttribute('data-variant-x-price');

            const superContainer = target.closest('options-selection');
            const selectContainer = target.closest('.options-selection__select');
            const labelName = selectContainer.querySelector('.options-selection__select-label .variant-name-x');
            const labelPrice = selectContainer.querySelector('.options-selection__select-label .variant-price-x');

            const radioInputContainer = superContainer.querySelector('.options-selection__option-values');    
            const radioInput = radioInputContainer.querySelector(`[value="${selectedOptionName}"]`);
            
            if (radioInput) {
                const parent = radioInput.closest('.options-selection__option-value-label');
                const inputTrigger = parent.querySelector('.variant-option-xx');

                inputTrigger.click();
            }

            labelName.textContent = selectedOptionName;
            labelPrice.textContent = selectedOptionPrice;

        }
    }
    

}

const clickHandler = new ClickHandler();
